import { useState, useEffect } from "react";
import { workshopApi } from "../../../services/workshopApi";

/**
 * Custom hook to fetch workshop categories
 *
 * @returns {Object} { categories, loading, error, refetch }
 */
function useWorkshopCategories() {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchCategories = async () => {
    try {
      setLoading(true);
      setError(null);

      const response = await workshopApi.getWorkshopCategories();

      if (response.success) {
        setCategories(response.data.categories || []);
      } else {
        setError(new Error(response.message || "Failed to fetch categories"));
      }
    } catch (err) {
      setError(err);
// Fallback to empty array on error
      setCategories([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  return {
    categories,
    loading,
    error,
    refetch: fetchCategories,
  };
}

export default useWorkshopCategories;
